import Container from '../../Component/Container/index'
import DefaultStatus from './Status/Default'

const TextType = ({ content, collectionVisibility, collectionPreparatory }) => {
  return (
    <Container
      content={content}
      collectionVisibility={collectionVisibility}
      collectionPreparatory={collectionPreparatory}
    >
      <DefaultStatus content={content} />
    </Container>
  )
}

export default TextType
